/**
 * Título exibido para uma sessão na UI.
 * Prioridade: `display_name` (nome editado no admin) quando preenchido;
 * caso contrário mantém o comportamento anterior (grupo → serviço → "Consulta").
 */
export function getSessionDisplayTitle(session: Sessions.Session): string {
	const custom =
		typeof session.display_name === 'string'
			? session.display_name.trim()
			: '';
	if (custom.length > 0) return custom;

	if (session.type === 'GROUP') return 'Sessão em grupo';

	const fromApi =
		session.service_name ??
		session.services?.service_name ??
		(
			session.professional as {
				professional_services?: Array<{
					service?: { service_name?: string };
				}>;
			}
		)?.professional_services?.[0]?.service?.service_name;

	if (fromApi && String(fromApi).trim()) return String(fromApi).trim();

	return 'Consulta';
}
